import React from "react";

const DailySalesSummary = () => {
  return (
    <div>
      <h2 className="text-xl font-bold mb-4">📅 Daily Sales Summary</h2>
      <p>Show all sales done per day, total revenue, and breakdown.</p>
    </div>
  );
};

export default DailySalesSummary;
